import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_FranchiseHero = _resolveComponent("FranchiseHero")!
  const _component_FranchiseMenu = _resolveComponent("FranchiseMenu")!
  const _component_FranchiseBenefits = _resolveComponent("FranchiseBenefits")!
  const _component_FranchiseRequirements = _resolveComponent("FranchiseRequirements")!
  const _component_FranchiseProcess = _resolveComponent("FranchiseProcess")!
  const _component_FranchiseInvestment = _resolveComponent("FranchiseInvestment")!
  const _component_FranchiseContact = _resolveComponent("FranchiseContact")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, { class: "style-three" }),
    _createVNode(_component_PageTitle, {
      pageTitle: "Franchise",
      mainTitle: "Guac & Grill",
      subTitle: "Halal Mexican Food"
    }),
    _createVNode(_component_FranchiseHero),
    _createVNode(_component_FranchiseMenu),
    _createVNode(_component_FranchiseBenefits),
    _createVNode(_component_FranchiseRequirements),
    _createVNode(_component_FranchiseProcess),
    _createVNode(_component_FranchiseInvestment),
    _createVNode(_component_FranchiseContact)
  ], 64))
}